var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "modal-card-body" }, [
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Evento")]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            staticClass: "input",
            attrs: { type: "text", disabled: "" },
            domProps: { value: _vm.evento.nombre },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v("¿Que acción ejecuta el evento?"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.acciones, function (accion) {
            return _c(
              "div",
              { key: accion.id, staticClass: "control" },
              [
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": accion },
                    model: {
                      value: _vm.accionSelected,
                      callback: function ($$v) {
                        _vm.accionSelected = $$v
                      },
                      expression: "accionSelected",
                    },
                  },
                  [_vm._v(_vm._s(accion.nombre))]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.incompatibilidades, function (inc, index) {
            return _c("p", { key: index, staticClass: "help is-danger" }, [
              _c("i", { staticClass: "fas fa-times-circle" }),
              _vm._v(
                ' "' +
                  _vm._s(inc.queAccion) +
                  '" es incompatible con "' +
                  _vm._s(inc.cualAccion) +
                  '"'
              ),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("Descripción de la acción"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.descripcion,
                expression: "descripcion",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required: true}",
              },
            ],
            staticClass: "input",
            class: { "is-danger": _vm.errors.has("Descripcion de la acción") },
            attrs: { name: "Descripcion de la acción" },
            domProps: { value: _vm.descripcion },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.descripcion = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "help" }, [
            _vm._v("Describa en detalle de que se trata la acción"),
          ]),
          _vm._v(" "),
          _vm.errors.has("Descripcion de la acción")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("Descripcion de la acción"))),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.parametrosArray.includes("subunidad")
        ? _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Subunidad")]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "select is-fullwidth" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.subunidadSelected,
                        expression: "subunidadSelected",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { name: "Subunidad" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.subunidadSelected = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { disabled: "" }, domProps: { value: null } },
                      [_vm._v("- Seleccione una subunidad -")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.subunidades, function (s, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: index } },
                        [_vm._v(_vm._s(s.nombre))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.has("Subunidad")
        ? _c("span", { staticClass: "help is-danger" }, [
            _vm._v(_vm._s(_vm.errors.first("Subunidad"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.parametrosArray.includes("aspecto_id")
        ? _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Aspecto")]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "select is-fullwidth" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.aspectoSelected,
                        expression: "aspectoSelected",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { name: "Aspecto" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.aspectoSelected = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { disabled: "" }, domProps: { value: null } },
                      [_vm._v("- Seleccione un aspecto -")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.aspectosSerie, function (a, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: a.id } },
                        [_vm._v(_vm._s(a.nombre))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.alertNoAspectos
        ? _c("div", { staticClass: "notification is-warning" }, [_vm._m(1)])
        : _vm._e(),
      _vm._v(" "),
      _vm.alertNoSubunidades
        ? _c("div", { staticClass: "notification is-warning" }, [_vm._m(2)])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-card-foot is-justify-content-flex-end" }, [
      _c(
        "button",
        {
          staticClass: "button is-dark is-outlined",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button is-primary",
          attrs: { type: "button" },
          on: { click: _vm.submit },
        },
        [_vm._v("Crear acción")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title is-800" }, [
        _vm._v("Nueva Acción"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("No se puede agregar la acción al evento")]),
      _c("br"),
      _vm._v("La serie documental no cuenta con aspectos."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("No se puede agregar la acción al evento")]),
      _c("br"),
      _vm._v("La serie documental no cuenta con subunidades."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }